import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './DataVisualization.css';

const DataVisualization = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="data-visualization-page">
      <div className="data-visualization-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'Data Visualization')}
        />

        <div className="data-visualization-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="data-visualization-header">
          <h1>Data Visualization</h1>
          <p className="data-visualization-subtitle">
            We transform complex data into meaningful visual insights that
            empower organizations to make informed, data-driven decisions.
            Our data visualization solutions combine analytics, design,
            and technology to deliver clarity, performance visibility,
            and strategic intelligence.
          </p>
        </div>

        <div className="data-visualization-content">
          <section className="data-visualization-section">
            <h2>What We Offer</h2>

            <div className="data-visualization-service">
              <h3>Interactive Dashboard Development</h3>
              <p>
                We design dynamic dashboards that present real-time data
                through charts, graphs, and KPIs, enabling faster
                operational and executive decision-making.
              </p>
            </div>

            <div className="data-visualization-service">
              <h3>Business Intelligence Visualization</h3>
              <p>
                Our BI visualization solutions convert raw datasets into
                structured visual reports that highlight trends,
                performance metrics, and growth opportunities.
              </p>
            </div>

            <div className="data-visualization-service">
              <h3>Custom Charts & Reporting</h3>
              <p>
                We create tailored visual models including heat maps,
                scatter plots, financial graphs, and comparative
                analytics reports aligned to business needs.
              </p>
            </div>

            <div className="data-visualization-service">
              <h3>Data Storytelling & Presentation</h3>
              <p>
                We craft compelling visual narratives that simplify
                complex insights, helping stakeholders understand data
                impact through structured storytelling.
              </p>
            </div>

            <div className="data-visualization-service">
              <h3>Real-Time Monitoring Systems</h3>
              <p>
                Our solutions enable live tracking of operational,
                financial, and system metrics through continuously
                updated visualization environments.
              </p>
            </div>

            <div className="data-visualization-service">
              <h3>Predictive & Analytical Visualization</h3>
              <p>
                We visualize forecasting models and predictive analytics
                outputs, allowing organizations to anticipate risks,
                trends, and future opportunities.
              </p>
            </div>
          </section>

          <section className="data-visualization-section">
            <h2>Tools & Technologies</h2>

            <div className="tools-grid">
              <div className="tool-category">
                <h4>BI Platforms</h4>
                <p>Power BI, Tableau</p>
              </div>

              <div className="tool-category">
                <h4>Visualization Libraries</h4>
                <p>D3.js, Chart.js</p>
              </div>

              <div className="tool-category">
                <h4>Analytics Integration</h4>
                <p>Python, R, SQL Analytics</p>
              </div>

              <div className="tool-category">
                <h4>Dashboard Development</h4>
                <p>React, Web-based Dashboards</p>
              </div>

              <div className="tool-category">
                <h4>Data Processing</h4>
                <p>ETL Pipelines, Data Warehousing</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DataVisualization;

